import React from "react";
import { Button } from "primereact/button";

import { useApolloClient } from "@apollo/client";

/** PROVIDERS */
import CALL from "../../provider/Calls/query";

/** contexts */
import { useSettings } from "../../context/settings";

/** utils */
import { getGraphsqErros } from "../../utilities/functions";
import moment from "moment";

const Prescription: React.FC<iProps> = ({ call_id, setVisible, medicines = [] }) => {
    const apollo = useApolloClient();
    const settings = useSettings();

    const [record, setRecord] = React.useState<iCall>();

    const [loading, setLoading] = React.useState<boolean>(false);

    const print = () => {
        window.print();
    };

    const loadRecord = async () => {
        setLoading(true);

        apollo
            .query({
                query: CALL,
                variables: {
                    id: parseInt(`${call_id}`),
                },
                fetchPolicy: "no-cache",
            })
            .then(response => {
                const data: iCall = response.data.call;
                setRecord(data);
                setLoading(false);
            })
            .catch(error => {
                settings?.setErrorMessage(getGraphsqErros(error));
                settings?.setVisibleError(true);
                setLoading(false);
            });
    };

    React.useEffect(() => {
        if (call_id) loadRecord();
    }, [call_id]);

    return (
        <div className="layout-invoice-page">
            <Button
                type="button"
                label="Impressão"
                icon="pi pi-print"
                onClick={print}
                style={{ display: "block", marginBottom: "20px", marginLeft: "6px" }}
                className="p-button-outlined invoice-button"></Button>

            <div className="grid">
                <div className="col">
                    <div className="card">
                        <div id="invoice-content">
                            <div className="invoice">
                                <div className="invoice-header">
                                    <div className="invoice-company flex align-items-center">
                                        <img className="invoice-logo" src={`logo.png`} style={{ height: 70 }} alt="atlantis-layout" />
                                    </div>
                                    <div className="ml-2 text-right">
                                        <div className="customer-id">
                                            Paciente: <b>{record?.patient?.name}</b>
                                        </div>
                                        {/* <div className="invoice-address">{record?.patient?.cpf ?? record?.patient?.rg ?? "-"}</div> */}
                                    </div>
                                </div>

                                <div className="invoice-to">
                                    <div className="invoice-date">{moment().utc().format("DD/MM/YYYY")}</div>
                                    <div className="invoice-id">
                                        Receita <span>#{record?.id?.toString().padStart(5, "0")}</span>
                                    </div>
                                    <div className="invoice-to-name" style={{ fontSize: 22, lineHeight: "25px" }}>
                                        {record?.patient?.name}
                                    </div>
                                    <div className="invoice-to-info" style={{ fontSize: 16, lineHeight: "20px" }}>
                                        <div>
                                            Data de nascimento: {moment.utc(record?.patient?.birth_date).format("DD/MM/YYYY")},{" "}
                                            {moment().utc().diff(moment(record?.patient?.birth_date).utc(), "years")} anos
                                        </div>
                                        {/* <div>CPF: {record?.patient?.cpf ?? "-"}</div>
                                        <div>RG: {record?.patient?.rg ?? "-"}</div> */}
                                        <div>
                                            {record?.patient?.region ?? "-"}, {record?.patient?.city ?? "-"}
                                        </div>
                                    </div>
                                </div>

                                <div className="invoice-items">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ width: 50, flex: "auto" }}>Quantidade</th>
                                                <th className="text-left">Medicamento</th>
                                                <th>Dosagem</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {record?.items.data.map((item: any, index: number) => (
                                                <tr key={`print-${index}`}>
                                                    <td style={{ width: 50, flex: "auto" }}>{item.amount ?? 1}</td>
                                                    <td className="text-left">{medicines.find(i => `${i.id}` === `${item.medicine_id}`)?.name}</td>
                                                    <td>{item.dosage}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="invoice-notes">
                                    <div className="text-center">
                                        <br />
                                        <br />
                                        _____________________________________
                                        <br />
                                        <br />
                                        {record?.user?.name}
                                        <br />
                                        <b>{record?.user?.notes}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Prescription;

interface iProps {
    call_id: any;
    setVisible: Function;
    medicines: iMedicine[];
}
